import {createContext} from 'react';

const sessionContext = createContext({
  'handleLogOutClick': ()=>{}
});

export default sessionContext;